import { applyMiddleware, compose, createStore } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import throttle from 'lodash/throttle';

import unauthMiddleware from './middlewares/unauth-middleware';

import history from './history';
import { loadState, saveState } from './localstorage';
import rootReducer from './modules';

const LOCAL_STORAGE_DEBOUNCE_MS = 300;

// Create a connected root reducer for dispatching history actions
const connectedRootReducer = connectRouter(history)(rootReducer);

// Load the persistedState from localStorage or sessionStorage
// and uses it as initialState if available
const initialState = loadState() || {};
const enhancers = [];
const middleware = [
  thunk,
  routerMiddleware(history),
  unauthMiddleware,
];

if (process.env.NODE_ENV === 'development') {
  const { __REDUX_DEVTOOLS_EXTENSION__ } = window;

  if (typeof __REDUX_DEVTOOLS_EXTENSION__ === 'function') {
    enhancers.push(__REDUX_DEVTOOLS_EXTENSION__());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers,
);

const store = createStore(
  connectedRootReducer,
  initialState,
  composedEnhancers,
);

// on state change, save the current state to localStorage
//
// the throttle is an important step, as it debounces all state
// changes until the app has stablized for atleast a second. saveState
// includes JSON.stringify which can be a bit expensive memory wise for large
// state objects and shouldn't be called hundreds of times a second.
store.subscribe(throttle(() => {
  // currently this will save all of the state in the store including any
  // state that feels more effemeral and which would likely be expected
  // to be reset by a page reload (like a filter setting or something like
  // that). In the future we could send a subset of the state here, as an optionsdf
  // or handle exceptions to the rule in the components themselves, or selectively
  // delete parts of the state we don't want saved in saveState. I am intentionally
  // pushing this design decision off until I have a better idea of what our specific
  // app would benefit from.
  saveState(store.getState());
}, LOCAL_STORAGE_DEBOUNCE_MS));

export default store;
